// extracted by mini-css-extract-plugin
export default {"formsContainer":"CompanyProfilePage_formsContainer__4ot+M","form":"CompanyProfilePage_form__7xNcR","formDivider":"CompanyProfilePage_formDivider__CiPq+"};